import axios from 'axios';
import axiosRetry from 'axios-retry';

import { STATUS_CODE } from '../constants/statusCode';

const CONFIG_BASE_URL = '/api';

export const axiosInstance = axios.create({
  baseURL: CONFIG_BASE_URL,

  transformResponse: [
    data => {
      try {
        if (data.startsWith(")]}',\n")) {
          return JSON.parse(data.slice(6));
        }
        return data;
      } catch (error) {
        throw Error(
          `Error parsing response JSON data - ${JSON.stringify(error)}`,
        );
      }
    },
  ],
});

// Configure retry behavior
axiosRetry(axiosInstance, {
  retries: 3,
  retryDelay: retryCount => {
    // Base delay with exponential backoff (1s, 2s, 4s)
    const baseDelay = 1000 * 2 ** (retryCount - 1);
    // Add random jitter between 0-100% of the base delay
    const jitter = Math.random() * baseDelay;
    return baseDelay + jitter;
  },
  retryCondition: error =>
    // Only retry on network errors or 5xx server errors
    error.code === 'ECONNABORTED' ||
    !error.response ||
    error.response?.status === STATUS_CODE.INTERNAL_SERVER_ERROR ||
    error.response?.status === STATUS_CODE.SERVICE_UNAVAILABLE ||
    error.response?.status === STATUS_CODE.GATEWAY_TIMEOUT,
});
